// extracted by mini-css-extract-plugin
export default {"main":"App_main__g-ZH2","game":"App_game__O5AhD","disableAnimations":"App_disableAnimations__djH3o"};